import { Fragment, useState, useEffect } from 'react'
import API from '../../api'
import Slider from 'react-slick'
import store from 'store2'
import get from 'lodash/get'
import { FormattedMessage } from 'react-intl'
import './previous-search.sass'
import DateFormat from '../helpers/DateFormat'
import TwoDatesFormat from '../helpers/TwoDatesFormat'
import { generateGuestsText } from '../forms/GuestPicker'
import { getToken } from '../../utils'
import PreviousSearchHandler from './PreviousSearchHandler'

const settings = {
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: false,
  dots: false,
  responsive: [
    { breakpoint: 1025, settings: { slidesToShow: 4, slidesToScroll: 4 } },
    { breakpoint: 769, settings: { slidesToShow: 2.5, slidesToScroll: 1, arrows: false } },
    { breakpoint: 481, settings: { slidesToShow: 1.2, slidesToScroll: 1, arrows: false } },
  ],
}

const PreviousSearchType = function({ item }) {
  let type = ''
  if(item.modelType === 'Shop') {
    if(item.kind === 10) {
      type = (<p className='item-type'>
        <FormattedMessage id='liveabord' defaultMessage='Liveaboard' />,&nbsp;
        <DateFormat date={get(item, 'departureMonth.from')} format={'MMMM YYYY'} />
      </p>)
    } else {
      type = (<p className='item-type'>
        <FormattedMessage id='dive_resort' defaultMessage='Dive resort' />,&nbsp;
        <TwoDatesFormat dateFrom={item.dateFrom} dateTo={item.dateTo} />
      </p>)
    }
  } else if(item.modelType === 'Travel guides') {
    type = (<p className='item-type'>
      <FormattedMessage id='travel_guide' defaultMessage='Travel guides' />,&nbsp;
      <TwoDatesFormat dateFrom={item.dateFrom} dateTo={item.dateTo} />
    </p>)
  } else if(item.modelType === 'Fleet') {
    type = (<p className='item-type'>
      <FormattedMessage id='fleet' defaultMessage='Fleet' />,&nbsp;
      <DateFormat date={get(item, 'departureMonth.from')} format={'MMMM YYYY'} />
    </p>)
  } else if(item.modelType === 'Location' || item.modelType === 'PopupLink') {
    type = (<p className='item-type'>
      {
        item.searchKind === 'LA'
          ? (<Fragment>
            <FormattedMessage id='liveabords' defaultMessage='Liveaboards' />,&nbsp;
            <DateFormat date={get(item, 'departureMonth.from')} format={'MMMM YYYY'} />
          </Fragment>) : null
      }
      {
        item.searchKind === 'DR'
          ? (<Fragment>
            <FormattedMessage id='resorts' defaultMessage='Dive resorts' />,&nbsp;
            <TwoDatesFormat dateFrom={item.dateFrom} dateTo={item.dateTo} />
          </Fragment>) : null
      }
      {
        item.searchKind === 'Group'
          ? (<Fragment>
            <FormattedMessage id='group_trips' defaultMessage='Group trips' />,&nbsp;
            <DateFormat date={get(item, 'departureMonth.from')} format={'MMMM YYYY'} />
          </Fragment>) : null
      }
    </p>)
  }

  return type
}

export default function PreviousSearch() {
  const [previousSearch, setPreviousSearch] = useState([])

  useEffect(function() {
    const PreviousItems = new PreviousSearchHandler()
    PreviousItems.getResults().then(function(results) {
      setPreviousSearch(results)
    })
  }, [])

  if(!previousSearch.length) {
    return ''
  }

  function handleClick(item) {
    store('roomParams', item.roomParams)
    store('departure_date', item.departureMonth)
    store('date', [item.dateFrom, item.dateTo])
    window.location.href = item.url
  }

  return (
    <div className='previous-search'>
      <p className='previous-search__title'>
        <FormattedMessage id='search-again' defaultMessage='Search again' />
      </p>
      <div className='previous-search__list'>
        <Slider {...settings}>
          {
            previousSearch.map((item) => {
              return (<div key={item} className='previous-search__item pointer' onClick={() => handleClick(item)}>
                <i className='font-icons find-icon' />
                <p className='item-title'>{ item.title }</p>
                <PreviousSearchType item={item} />
                <p className='item-rooms'>{ generateGuestsText(item.roomParams) }</p>
              </div>)
            })
          }
        </Slider>
      </div>
    </div>
  )
}
